import React, { useEffect, useRef, useState } from 'react';
import './custom.styles.scss';
import cls from './bottombar.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Icon, useDimension } from 'lb-components';

import {
  CloseIcon,
  SuccessIconFill,
  UserProfileIcon,
  DepositPromoBanners,
} from '../../assets/icons';

import { Button } from 'react-bootstrap';
import cx from 'classnames';
import UseBottomBar from 'lb-store/src/hooks/useBottomBar';
import UserPageRouter from './UserPageRouter';
import UserVerificationIcon from './UserVerificationIcon/UserVerificationIcon';
import {
  UseUser,
  UseNavigation,
  UseVerification,
  UseAlert,
} from 'lb-store/src/hooks';
import { Toast, useTranslation } from 'lb-store';
import { CSSTransition } from 'react-transition-group';

const BottomNavBar = ({ navRefs, nav, callback }) => {
  const { t, i18n } = useTranslation();
  const backdropRef = useRef();
  const bottomNavRef = useRef();
  const contentRef = useRef();
  const [isOpen, setIsOpen] = useState(false);
  const [route, setRoute] = useState('main');
  const {
    addListener,
    unsubscribe,
    bottomBarListener,
    toggle,
    Close,
    Open,
    updateHeight,
  } = UseBottomBar(callback);
  const verificationModal = UseVerification();

  const { User } = UseUser();
  const alert = UseAlert();

  const [showPinMessage, setShowPinMessage] = useState(false);
  const pinMessageRef = useRef();

  const { clientHeight } = useDimension();
  const heightRef = useRef();
  useEffect(() => {
    //update height value for listener
    heightRef.current = clientHeight;

    //if open, adjust height on resize
    let menuHeight;
    try {
      menuHeight = parseInt(bottomNavRef.current.style.height);
    } catch (e) {
      menuHeight = 0;
    }
    if (menuHeight > 0) {
      updateHeight(false, clientHeight, {
        bottomNavRef: bottomNavRef.current,
        backDropRef: backdropRef.current,
      });
    }
  }, [clientHeight]);

  useEffect(() => {
    const listener = bottomBarListener.subscribe('bottomBar', (data) => {
      toggle({ ...data, height: heightRef.current });
    });
    addListener({
      ref: bottomNavRef,
      backRef: backdropRef,
      contRef: contentRef,
      navRefs: navRefs,
      setRoute: setRoute,
    });
    if (nav.get('nav') === 'open') {
      Open({});
    }
    return () => {
      unsubscribe();
      listener.unsubscribe();
    };
  }, []);

  useEffect(() => {
    if (route) {
      if (route === 'ticket-history') {
        nav.navigate('/sport#ticketHistory');
        Close();
        setRoute('main');
      } else {
        nav.set('route', route);
      }
    } else {
      nav.remove('route');
    }
  }, [route]);

  const setHeight = () => {};

  const navigate = (route) => {
    Close();
    nav.navigate(route);
  };
  const Header = ({ nav = 'main' }) => {
    return (
      <div className={cls.header}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-start',
          }}
        >
          {nav === 'main' || nav.menu === '' ? (
            <div className={cls.userInfo}>
              <UserVerificationIcon />
              <div className={cls.userDetails}>
                <span className={cls.username}>{User?.data?.username}</span>
                <span
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    navigator.clipboard.writeText(User?.data?.pin).then(() => {
                      if (!showPinMessage) {
                        setShowPinMessage(true);
                        setTimeout(() => {
                          setShowPinMessage(false);
                        }, 2000);
                      }
                    });
                  }}
                >
                  <span className={cls.pin}>{User?.data?.pin}</span>
                  <CSSTransition
                    in={showPinMessage}
                    timeout={300}
                    unmountOnExit
                    classNames={{
                      enter: cls.enter,
                      enterActive: cls.enterActive,
                      enterDone: cls.enterDone,
                      exit: cls.exit,
                      exitActive: cls.exitActive,
                    }}
                    nodeRef={pinMessageRef}
                  >
                    <div className={cls.message} ref={pinMessageRef}>
                      <Icon
                        type={'vec'}
                        Icon={SuccessIconFill}
                        style={{
                          height: '1.8rem',
                          width: '1.8rem',
                          backgroundColor: '#fff',
                        }}
                      />
                      <span>{t('პინ კოდი დაკოპირებულია')}</span>
                    </div>
                  </CSSTransition>
                </span>
              </div>
              {!User?.data?.verified && (
                <Button
                  className={cls.verificationBtn}
                  variant='link'
                  onClick={() => {
                    verificationModal.open({
                      onSuccess: () => {
                        alert.open({
                          actionLabel: 'გაეცანით მიმდინარე აქციებს',
                          onSuccess: ({ cancel }) => {
                            cancel();
                            navigate('/news');
                          },
                          cancelLabel: 'დაბრუნება',
                          message: (
                            <p
                              style={{
                                fontFamily: 'lbet-st',
                                margin: 0,
                                fontSize: '1.5rem',
                              }}
                            >
                              {t(
                                'დოკუმენტები ატვირთულია მიმდინარეობს ვერიფიკაცია ვერიფიცაკიის შესახებ შეტყობინებას მიიღებთ SMS-ით'
                              )}
                            </p>
                          ),
                        });
                      },
                    });
                  }}
                >
                  {t('ვერიფიკაცია')}
                </Button>
              )}
            </div>
          ) : (
            <FontAwesomeIcon
              icon={faArrowLeft}
              color={'#d5d8ec'}
              fontSize={'3rem'}
              onClick={() => setRoute('main')}
            />
          )}
        </div>
        {nav !== 'main' && (
          <div style={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
            <span className={cls.balance}>
              {t('ბალანსი')}: {User?.balance?.balance} <sup>₾</sup>
            </span>
          </div>
        )}

        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
          }}
          onClick={(e) => {
            setRoute('main');
            Close();
          }}
        >
          <Icon Icon={CloseIcon} width={'2.7rem'} height={'2.7rem'} />
        </div>
      </div>
    );
  };
  return (
    <div
      className={cls.bottomNavBarWrapper}
      ref={bottomNavRef}
      id={'bottomBar'}
    >
      <div className={cls.bottomNavBar}>
        {Header({ nav: route })}
        <div className={cls.content} ref={contentRef}>
          <UserPageRouter
            route={route}
            setRoute={setRoute}
            navigate={navigate}
            close={Close}
          />
        </div>
      </div>
      <div
        ref={backdropRef}
        onClick={() => Close()}
        className={cx(cls.backDrop, {
          [cls.active]: isOpen,
        })}
      />
    </div>
  );
};
export default BottomNavBar;
